export default "__VITE_ASSET__DcE2Xyok__"